import { useNavigate as useRouterNavigate } from 'react-router'


declare global {

  var prerelease: {
    prerelease: string
  } | undefined
}

export function srcWithPrerelease(src: string): string
export function srcWithPrerelease(src: undefined): undefined
export function srcWithPrerelease(src: string | undefined): string | undefined
export function srcWithPrerelease(src: string | undefined): string | undefined {
  if (!src) {
    return src
  }

  const url = new URL(src, globalThis.location.href)
  if (url.hostname === globalThis.location.hostname && globalThis.prerelease && typeof globalThis.prerelease === 'object') {
    for (const [ name, value ] of Object.entries(globalThis.prerelease)) {
      url.searchParams.set(name, value)
    }
  }

  return url.hostname === globalThis.location.hostname ? `${url.pathname}${url.search}${url.hash}` : url.toString()
}

export function urlSearchWithPrerelease(src: string | URLSearchParams | undefined): string | undefined {
  if (!src) {
    return src
  }

  const params = typeof src === 'string' ? new URLSearchParams(src) : src
  if (globalThis.prerelease && typeof globalThis.prerelease === 'object') {
    for (const [ name, value ] of Object.entries(globalThis.prerelease)) {
      params.set(name, value)
    }
  }

  return params.toString()
}

export function useNavigate(): ReturnType<typeof useRouterNavigate> {
  const navigate = useRouterNavigate()

  return (...args) => {
    if (typeof args[0] === 'string') {
      navigate(srcWithPrerelease(args[0]), args[1] as Exclude<Parameters<typeof navigate>, [number]>)
    } else if (typeof args[0] === 'object' && args[0] !== null) {
      navigate({
        ...args[0],
        search: urlSearchWithPrerelease(args[0].search)
      }, args[1] as Exclude<Parameters<typeof navigate>, [number]>)
    } else if (typeof args[0] === 'number') {
      return navigate(args[0])
    } else {
      navigate(args[0], args[1] as Exclude<Parameters<typeof navigate>, [number]>)
    }
  }
}
